// extracted by mini-css-extract-plugin
export var infoBlock = "info-block-module--infoBlock--GJdI_";